import { render, staticRenderFns } from "./ListServiceOrders.vue?vue&type=template&id=fd5e82e4&"
import script from "./ListServiceOrders.vue?vue&type=script&lang=js&"
export * from "./ListServiceOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports